import { all } from "redux-saga/effects";
import { watchInviteTrackingInvitesSaga } from "./inviteTrackingInvitesSaga";
import {
  watchAuthSaga,
  watchLinkedInSaga,
  watchSendEmailVerificationSaga,
} from "./authSaga";
import {
  watchDocSaga,
  watchUploadDocSaga,
  watchRemoveDocSaga,
} from "./docSaga";

import { watchcheckUserSaga } from "./chekckUserSaga";
import {
  watchGetCandidateSkillListing,
  watchPerUserSkillListingSaga,
  watchSkillListingCountSaga,
  watchSkillListingTotalCountSaga,
  watchKeySearchSkill,
} from "./skillListingSaga";

import {
  watchSearchCompaniesAndIndustriesSaga,
  watchSearchLocationSaga,
  watchSearchLocationSuggestionsSaga,
  watchSearchRegionSuggestionsSaga,
  watchSearchSkillsSaga,
  watchSearchStateSuggestionsSaga,
} from "./searchLocationSaga";
import { watchCreateBidSaga, watchCreatemultiBidSaga } from "./createBidSaga";
import {
  watchUpdateBidSaga,
  watchFetchDeclinedReasonsBids,
} from "./updateBidSaga";

import { watchCheckUsernameUnique } from "./checkUserNameSaga";
import {
  watchFetchMessagesSaga,
  watchSendMessagesSaga,
  watchEditOfferSaga,
  watchGetInboxMessagesSaga,
  watchGetChatSaga,
  watchPostAttachmentSaga,
  watchMakeOfferSaga,
  watchGetMsgsCountsSaga,
  watchgetHrmsSaga,
  watchGetConversationCountSaga,
} from "./messagesSaga";

import {
  watchAddMessageFavouriteSaga,
  watchRemoveMessageFavouriteSaga,
} from "./messageFavouriteSaga";
import { watchRetractBidSaga } from "./retractBidSaga";
import { watchCreateInterviewSaga } from "./createInterviewSaga";
import { watchUpdateInterviewSaga } from "./updateInterviewSaga";
import {
  watchGetProfileDetails,
  watchGetProfileReviews,
  watchPostNotesSaga,
  watchgetNotesSaga,
  watchUpdateNotesSaga,
  watchDeleteNotesSaga,
  watchGetConversationIdSaga,
  watchRemovePrivateTalentSaga,
} from "./ProfileDetailSaga";
import { watchUpdatePersonalDetailsSaga } from "./updatePersonalDetailsSaga";
import {
  watchGetCompanyProfileDetailsSaga,
  watchUpdateCompanyProfileLinkedAccoutsSaga,
} from "./getCompanyProfileDetailsSaga";
import { watchGetPersonalDetailsLocationSaga } from "./getPersonalDetailsLocationSaga";
import { watchFetchAllGigsSaga } from "./fetchGigs";
import { watchGetFiltersSaga } from "./searchGetFiltersSaga";
import {
  watchGetkeywordsSuggestionsSaga,
  watchGetSearchSuggestionSaga,
  watchGetRecentSearchesSaga,
  watchGetTrendingJobsSaga,
  watchclearRecentSearchSaga,
} from "./searchSuggestionsSaga";
import { watchSearchSuggestionsSaga } from "./SearchSuggestionsSaga2";
import {
  watchCompanyDetailsDropdown,
  watchCompanyDetailsSaga,
} from "./CompanyDetailsSaga";
import { watchProfileSaga, watchGetABsSaga } from "./profileSaga";
import { watchGetCulturePhotosSaga } from "./ourCulturePhotosSaga";
import { watchFetchViewsSaga } from "./getViewsSaga";
import { watchUpdateEmpAlbumsSaga } from "./updateEmpAlbumsSaga";
import { watchEditEmpAlbumsSaga } from "./editEmpAlbumsSaga";
import { watchGetEmpAlbumsSaga } from "./getEmpAlbumsSaga";
import { watchCreateGigSaga } from "./createGigSaga.js";
import { watchGetSearchSkillsSaga } from "./getSearchSkillsSaga";
import { watchUpdateGigSaga } from "./updateGigSaga";
import { watchDeleteEmpAlbumsSaga } from "./deleteEmpAlbumsSaga";
import { watchUpdateProposalSaga } from "./updateProposalSaga";
import { watchFetchFollowersSaga } from "./getFollowersSaga";
import {
  watchGetJobListing,
  watchGetJobCounts,
  watchGetJobListingResult,
  watchGetCandidateCounts,
} from "./getJobListingSaga";
import {
  watchGetTemplatesSaga,
  watchUpdatePostJobSaga,
  watchGetJobTitleSaga,
} from "./PostAJobSaga";
import {
  watchGetDashboardDetails,
  watchGetReminders,
  watchGetDashboardInterviewDetails,
  watchGetDashboardMatchesDetails,
} from "./dashboardSaga";
import { watchGetRoles } from "./getRolesSaga";
import { watchdeleteJobSaga } from "./deleteJobSaga";
import {
  watchGetJobDetailSaga,
  watchGetJobBidDetailSaga,
} from "./getJobDetailSaga";
import { watchGetResume3dSaga } from "./getResume3dSaga";

import { watchFollowSaga, watchUnFollowSaga } from "./followSaga";
import { watchGetAllInterviewsSaga } from "./getAllInterviewsSaga";
import {
  watchGetSkillMatchesSaga,
  watchAddtoMatchesSaga,
  watchRemoveSkillMatches,
  watchFindMyMatches,
  watchFindMyMatchesCount,
  watchFindMyMatchesPaginationSaga,
  watchAddBatchMatchesSaga,
  watchAddSingleMatchesSaga,
} from "./skillMacthesSaga";
import {
  watchGetFavorites,
  watchPostFavorites,
  watchDeleteFavorites,
} from "./FavoritesSaga";
import {
  watchGetTimesheetListSaga,
  watchGetTimesheetSaga,
  watchApproveTimesheetSaga,
  watchGetGraphDetailsSaga,
  watchRejectTimesheetSaga,
  watchApproveTimeOffSaga,
  watchRejectTimeOffSaga,
  watchApproveAllTimesheetSaga,
  watchEditTimesheetSaga,
} from "./TimesheetSaga";
import {
  watchUpdateTeamMembersSaga,
  watchAddTeamMembersSaga,
  watchGetAllTeamMembersSaga,
  watchDeleteTeamMemberSaga,
} from "./TeamMembersSaga";
import { watchFetchTeamPageSaga } from "./TeamPageSaga";
import {
  watchGetNotifications,
  watchGetReadNotifications,
} from "./fetchNotification";
import { watchGetAllPaymentsSaga } from "./getAllPaymentsSaga";

import { watchGetMatchesSaga, watchGetMatchesSortSaga } from "./getMatchesSaga";
import { watchReactivateTeamMemberSaga } from "./reactivateTeamMemberSaga";
import { watchRatingSaga, watchDeleteRatingSaga } from "./Ratings&ReviewsSaga";
import { watchPutRatingSaga } from "./EditRatings&ReviewsSaga";

import { watchGetCandidatesSaga } from "./getCandidatesSaga";
import { watchGetRecentJobListing } from "./getRecentJoblistingSaga";
import {
  watchGetJobListingDraft,
  watchGetJobListingNewDraft,
} from "./getJoblistingDraftSaga";
import { watchGetCandidateCountSaga } from "./getCandidateCountSaga";
import { watchGetCompanyGigsSaga } from "./getCompanyGigsSaga";
import { watchviewIncrementSagaSaga } from "./viewIncrementSaga";
import { watchGetRatingSaga } from "./getRatingSaga";
import { watchMyGigFiltersSaga } from "./myGigFiltersSaga.js";
import {
  watchSearchMyGigsLocationSuggestionsSaga,
  watchSearchMyGigsSkillsSaga,
} from "./myGigsFiterSaga.js";
import { watchUserClickSaga, watchUserLandedSaga } from "./userTrackingSaga.js";
import { watchHRMDetailsSaga } from "./hrmDetailsSaga.js";
import { watchABSDetailsSaga } from "./absSaga.js";
import { watchCandidateSkillSaga } from "./candidateSkillSaga.js";
import { watchinvitedCandidateSaga } from "./invitedCandidateSaga.js";
import { watchConfigTimeSheetSaga, watchGetConfigTimeSheetSaga } from "./configTimeSheetSaga.js";
import { watchGetTimeOffListSaga } from "./TimeOffSaga.js";
import { watchGetVmsFilterSaga } from "./vmsSaga.js";
import { watchGetUserTagSaga } from "./tagSaga.js";
import { watchGetFacilityFilterSaga } from "./vmsfacilitysaga.js";
import {
  watchSearchExternalUsersSaga,
  watchGetAssociatedTalentsSaga,
  watchSearchSkillListingQuerySaga,
  watchGetExternalUserDetailSaga,
  watchFetchExternalContactSaga,
  watchNlSearchExternalSaga,
} from "./queryPageSaga.js";
import {
  watchFetchCreditsBalanceSaga,
  watchFetchCreditTransactionsSaga,
  watchFetchPlansSaga,
  watchFreeTrialModalSaga,
} from "./plansSaga.js";
import { watchWriteWithAiSaga, watchCreateFirstJobSaga } from "./writeWithAiSaga";
import { watchSearchDepartmentsSaga } from "./departmentSearchSaga.js";
import { watchSearchTalentsSaga } from "./talentSearchSaga.js";
import { watchCreateProjectSaga } from "./createProjectSaga.js";
import { watchFetchProjectsSaga } from "./fetchProjectsSaga.js";
import {
  watchAddProjectManagersSaga,
  watchFetchProjectDetailSaga,
  watchFetchProjectHistorySaga,
  watchUpdateProjectSaga,
  watchUpdateProjectStatusSaga,
} from "./projectDetailSaga.js";

export default function* rootSaga() {
  yield all([
    watchInviteTrackingInvitesSaga(),
    watchAuthSaga(),
    watchDocSaga(),
    watchUpdateProposalSaga(),
    watchUploadDocSaga(),
    watchLinkedInSaga(),
    watchRemoveDocSaga(),
    watchcheckUserSaga(),
    watchAddMessageFavouriteSaga(),
    // watchFetchSkillSaga(),
    watchSearchLocationSaga(),
    watchSearchRegionSuggestionsSaga(),
    watchSearchLocationSuggestionsSaga(),
    watchSearchStateSuggestionsSaga(),
    watchKeySearchSkill(),
    // watchFetchUserSkillListing(),
    watchFetchDeclinedReasonsBids(),
    watchCreateBidSaga(),
    watchCreatemultiBidSaga(),
    watchFetchMessagesSaga(),
    watchRetractBidSaga(),
    watchSendMessagesSaga(),
    watchgetHrmsSaga(),
    watchCreateInterviewSaga(),
    watchUpdateInterviewSaga(),
    watchGetProfileDetails(),
    watchGetProfileReviews(),
    watchUpdatePersonalDetailsSaga(),
    watchGetFiltersSaga(),
    watchMyGigFiltersSaga(),
    watchGetSearchSuggestionSaga(),
    watchGetkeywordsSuggestionsSaga(),
    watchSearchSuggestionsSaga(),
    watchGetCompanyProfileDetailsSaga(),
    watchGetCompanyGigsSaga(),
    watchUpdateCompanyProfileLinkedAccoutsSaga(),
    watchGetPersonalDetailsLocationSaga(),
    watchFetchAllGigsSaga(),
    watchCompanyDetailsDropdown(),
    watchCompanyDetailsSaga(),
    watchProfileSaga(),
    watchGetCulturePhotosSaga(),
    watchFetchViewsSaga(),
    watchUpdateEmpAlbumsSaga(),
    watchGetEmpAlbumsSaga(),
    watchCreateGigSaga(),
    watchGetSearchSkillsSaga(),
    watchUpdateBidSaga(),
    watchEditEmpAlbumsSaga(),
    watchDeleteEmpAlbumsSaga(),
    watchFetchFollowersSaga(),
    watchGetJobListing(),
    watchPerUserSkillListingSaga(),
    watchSkillListingCountSaga(),
    watchSkillListingTotalCountSaga(),
    watchGetTemplatesSaga(),
    watchdeleteJobSaga(),
    watchUpdateGigSaga(),
    watchUpdatePostJobSaga(),
    watchGetJobDetailSaga(),
    watchGetDashboardDetails(),
    watchGetDashboardInterviewDetails(),
    watchGetDashboardMatchesDetails(),
    watchGetRoles(),
    watchGetResume3dSaga(),
    watchCheckUsernameUnique(),
    watchFollowSaga(),
    watchUnFollowSaga(),
    watchGetSkillMatchesSaga(),
    watchGetAllInterviewsSaga(),
    watchGetFavorites(),
    watchAddtoMatchesSaga(),
    watchRemoveSkillMatches(),
    watchGetTimesheetListSaga(),
    watchApproveTimesheetSaga(),
    watchGetNotifications(),
    watchGetReadNotifications(),
    watchPostFavorites(),
    watchDeleteFavorites(),
    watchGetTimesheetSaga(),
    watchEditTimesheetSaga(),
    watchApproveAllTimesheetSaga(),
    watchApproveTimeOffSaga(),
    watchUpdateTeamMembersSaga(),
    watchAddTeamMembersSaga(),
    watchDeleteTeamMemberSaga(),
    watchGetGraphDetailsSaga(),
    watchRejectTimesheetSaga(),
    watchRejectTimeOffSaga(),
    watchGetMatchesSaga(),
    watchGetMatchesSortSaga(),
    watchGetAllPaymentsSaga(),
    watchReactivateTeamMemberSaga(),
    watchGetInboxMessagesSaga(),
    watchGetChatSaga(),
    watchRatingSaga(),
    watchPutRatingSaga(),
    watchGetCandidatesSaga(),
    watchGetJobTitleSaga(),
    watchPostAttachmentSaga(),
    watchMakeOfferSaga(),
    watchEditOfferSaga(),
    watchDeleteRatingSaga(),
    watchGetRecentSearchesSaga(),
    watchGetTrendingJobsSaga(),
    watchclearRecentSearchSaga(),
    watchFindMyMatches(),
    watchGetCandidateSkillListing(),
    watchRemoveMessageFavouriteSaga(),
    watchGetABsSaga(),
    watchGetRecentJobListing(),
    watchGetMsgsCountsSaga(),
    watchGetJobListingDraft(),
    watchPostNotesSaga(),
    watchgetNotesSaga(),
    watchUpdateNotesSaga(),
    watchDeleteNotesSaga(),
    watchGetCandidateCountSaga(),
    watchGetReminders(),
    watchviewIncrementSagaSaga(),
    watchSendEmailVerificationSaga(),
    watchGetJobCounts(),
    watchGetAllTeamMembersSaga(),
    watchFetchTeamPageSaga(),
    watchFindMyMatchesCount(),
    watchFindMyMatchesPaginationSaga(),
    watchGetConversationCountSaga(),
    watchGetConversationIdSaga(),
    watchGetJobBidDetailSaga(),
    watchGetRatingSaga(),
    watchSearchCompaniesAndIndustriesSaga(),
    watchSearchSkillsSaga(),
    watchGetJobListingResult(),
    watchGetJobListingNewDraft(),
    watchSearchMyGigsLocationSuggestionsSaga(),
    watchSearchMyGigsSkillsSaga(),
    watchRemovePrivateTalentSaga(),
    watchRemovePrivateTalentSaga(),
    watchGetCandidateCounts(),
    watchUserLandedSaga(),
    watchUserClickSaga(),
    watchHRMDetailsSaga(),
    watchABSDetailsSaga(),
    watchCandidateSkillSaga(),
    watchinvitedCandidateSaga(),
    watchConfigTimeSheetSaga(),
    watchGetConfigTimeSheetSaga(),
    watchAddBatchMatchesSaga(),
    watchAddSingleMatchesSaga(),
    watchGetTimeOffListSaga(),
    watchGetVmsFilterSaga(),
    watchGetUserTagSaga(),
    watchGetFacilityFilterSaga(),
    watchSearchExternalUsersSaga(),
    watchGetAssociatedTalentsSaga(),
    watchSearchSkillListingQuerySaga(),
    watchGetExternalUserDetailSaga(),
    watchFetchExternalContactSaga(),
    watchNlSearchExternalSaga(),
    watchFetchPlansSaga(),
    watchFetchCreditsBalanceSaga(),
    watchFetchCreditTransactionsSaga(),
    watchFreeTrialModalSaga(),
    watchWriteWithAiSaga(),
    watchCreateFirstJobSaga(),
    watchSearchDepartmentsSaga(),
    watchSearchTalentsSaga(),
    watchCreateProjectSaga(),
    watchFetchProjectsSaga(),
    watchFetchProjectDetailSaga(),
    watchUpdateProjectSaga(),
    watchFetchProjectHistorySaga(),
    watchAddProjectManagersSaga(),
    watchUpdateProjectStatusSaga(),
  ]);

}
